const cards = [
    {
        id: "e4088dd6c39d9e791ff493185b9a9e4f",
        createBy: "jeecg",
        createTime: "2020-05-14",
        updateBy: "fdsf",
        updateTime: "2021-01-29",
        sysUserId: "e4f5294f25885c3c33e682d7c09b5023",
        projectName: "delivery",
        projectTitle: "delivery",
        projectStatus: 0,
        projectLikeNum: 2,
        projectDescription: "delivery",
        projectImage: "",
        projectParams: '{"url":"123123","api":"123123"}',
        tagIds: "",
        tagNames: [],
        userName: "hxg",
        realName: "胡小根",
        avatar: "",
        projectLikeId: "01170a8a479377289ad90f0563131d9c",
        likeStatus: 1,
        delFlag: 0,
    },
    {
        id: "ee8fea26ba7f0b428bcbdd0c6e75e38e",
        createBy: "jeecg",
        createTime: "2020-05-14",
        updateBy: "admin",
        updateTime: "2021-01-29",
        sysUserId: "e4f5294f25885c3c33e682d7c09b5023",
        projectName: "test",
        projectTitle: "test",
        projectStatus: 0,
        projectLikeNum: null,
        projectDescription: "test",
        projectImage: "",
        projectParams:
            '{"api":"111","url":"111","liveContainer":{"cluster":"cluster1.live","host":"192.168.16.14"}}',
        tagIds: "",
        tagNames: [],
        userName: "hxg",
        realName: "胡小根",
        avatar: "",
        projectLikeId: "505c5e4c0e368b329b86aff67b54f536",
        likeStatus: 0,
        delFlag: 0,
    },
    {
        id: "7aa13175b216b27abc2fc4e54f568093",
        createBy: "jeecg",
        createTime: "2020-10-16",
        updateBy: "fdsf",
        updateTime: "2021-02-10",
        sysUserId: "ced631c2542b20272eb840a09faf2282",
        projectName: "test",
        projectTitle: "test0210",
        projectStatus: 0,
        projectLikeNum: null,
        projectDescription: "test",
        projectImage: null,
        projectParams: '{"url":"111213","api":"1111231"}',
        tagIds: "",
        tagNames: [],
        userName: "haomo",
        realName: "毫末",
        avatar: "",
        projectLikeId: "",
        likeStatus: 0,
        delFlag: 0,
    },
    {
        id: "962de4c612a555638840267fba2e72b9",
        createBy: "jeecg",
        createTime: "2020-10-16",
        updateBy: "fdsf",
        updateTime: "2021-02-19",
        sysUserId: "ced631c2542b20272eb840a09faf2282",
        projectName: "ant-design",
        projectTitle: "ant-design",
        projectStatus: 0,
        projectLikeNum: 1,
        projectDescription: "ant-design",
        projectImage: null,
        projectParams:
            '{"api":"","url":"1111","liveContainer":{"cluster":"cluster1.live"}}',
        tagIds: ",,,,14,15,16,,,,,,,,",
        tagNames: ["社交应用", "游戏", "电子商务"],
        userName: "haomo",
        realName: "毫末",
        avatar: "",
        projectLikeId: "",
        likeStatus: 0,
        delFlag: 0,
    },
    {
        id: "c94ca957d45682e2a041b3750d269caa",
        createBy: "jeecg",
        createTime: "2020-10-22",
        updateBy: "hxg",
        updateTime: "2021-02-10",
        sysUserId: "ced631c2542b20272eb840a09faf2282",
        projectName: "大屏可视化",
        projectTitle: "BigScreen",
        projectStatus: 0,
        projectLikeNum: null,
        projectDescription: "大屏可视化相关的组件和页面",
        projectImage: null,
        projectParams: '{"url":"","api":""}',
        tagIds: "",
        tagNames: ["社交应用", "游戏", "电子商务"],
        userName: "haomo",
        realName: "毫末",
        avatar: "",
        projectLikeId: "",
        likeStatus: 0,
        delFlag: 0,
    },
    {
        id: "ac5e3a1217e713e75e683915ec0abc9b",
        createBy: "jeecg",
        createTime: "2020-10-29",
        updateBy: "admin",
        updateTime: "2021-01-11",
        sysUserId: "ced631c2542b20272eb840a09faf2282",
        projectName: "BigScreeen",
        projectTitle: "BigScreeen",
        projectStatus: 0,
        projectLikeNum: null,
        projectDescription: "BigScreeen",
        projectImage: null,
        projectParams:
            '{"selectedSize":"800 × 450","sizeDesignByCustom":[{"phoneName":"大屏","phoneSize":"800 × 450"}]}',
        tagIds: "",
        tagNames: [],
        userName: "haomo",
        realName: "毫末",
        avatar: "",
        projectLikeId: "",
        likeStatus: 0,
        delFlag: 0,
    },
    {
        id: "38aa0b15831604e9031fd5274d6f9523",
        createBy: "jeecg",
        createTime: "2020-11-02",
        updateBy: null,
        updateTime: null,
        sysUserId: "ced631c2542b20272eb840a09faf2282",
        projectName: "ant-design-rn",
        projectTitle: "ant-design-rn",
        projectStatus: 0,
        projectLikeNum: null,
        projectDescription: "ant-design-rn",
        projectImage: null,
        projectParams: null,
        tagIds: "",
        tagNames: [],
        userName: "haomo",
        realName: "毫末",
        avatar: "",
        projectLikeId: "",
        likeStatus: 0,
        delFlag: 0,
    },
]

const teamList = [
    {
        id: "1",
        headImg: require("@/assets/avatar.png"),
        name: "团队名称",
        description: "设计工作上最重要的是针对人们习以为常，认为理所当然的事物来做一些思考",
        memberLimit: 10,
        memberNum: 6,
    }, {
        id: "2",
        headImg: require("@/assets/avatar.png"),
        name: "团队名称",
        description: "设计工作上最重要的是针对人们习以为常，认为理所当然的事物来做一些思考",
        memberLimit: 10,
        memberNum: 6,
    },
    {
        id: "3",
        headImg: require("@/assets/avatar.png"),
        name: "团队名称",
        description: "设计工作上最重要的是针对人们习以为常，认为理所当然的事物来做一些思考",
        memberLimit: 10,
        memberNum: 6,
    },
    {
        id: "4",
        headImg: require("@/assets/avatar.png"),
        name: "团队名称",
        description: "设计工作上最重要的是针对人们习以为常，认为理所当然的事物来做一些思考",
        memberLimit: 10,
        memberNum: 6,
    },
    {
        id: "5",
        headImg: require("@/assets/avatar.png"),
        name: "团队名称",
        description: "设计工作上最重要的是针对人们习以为常，认为理所当然的事物来做一些思考",
        memberLimit: 10,
        memberNum: 6,
    },
    {
        id: "6",
        headImg: require("@/assets/avatar.png"),
        name: "团队名称",
        description: "设计工作上最重要的是针对人们习以为常，认为理所当然的事物来做一些思考",
        memberLimit: 10,
        memberNum: 6,
    },
    {
        id: "7",
        headImg: require("@/assets/avatar.png"),
        name: "团队名称",
        description: "设计工作上最重要的是针对人们习以为常，认为理所当然的事物来做一些思考",
        memberLimit: 10,
        memberNum: 6,
    },
    {
        id: "8",
        headImg: require("@/assets/avatar.png"),
        name: "团队名称",
        description: "设计工作上最重要的是针对人们习以为常，认为理所当然的事物来做一些思考",
        memberLimit: 10,
        memberNum: 6,
    },
    {
        id: "9",
        headImg: require("@/assets/avatar.png"),
        name: "团队名称",
        description: "设计工作上最重要的是针对人们习以为常，认为理所当然的事物来做一些思考",
        memberLimit: 10,
        memberNum: 6,
    },
    {
        id: "10",
        headImg: require("@/assets/avatar.png"),
        name: "团队名称",
        description: "设计工作上最重要的是针对人们习以为常，认为理所当然的事物来做一些思考",
        memberLimit: 10,
        memberNum: 6,
    },
]

const memberList = [
    {
        id: "1",
        headImg: require("@/assets/avatar.png"),
        name: "张三",
        identity: "管理员",
    },
    {
        id: "2",
        headImg: require("@/assets/avatar.png"),
        name: "张三",
        identity: "管理员",
    },
    {
        id: "3",
        headImg: require("@/assets/avatar.png"),
        name: "张三",
        identity: "管理员",
    },
    {
        id: "4",
        headImg: require("@/assets/avatar.png"),
        name: "张三",
        identity: "管理员",
    },
    {
        id: "5",
        headImg: require("@/assets/avatar.png"),
        name: "张三",
        identity: "管理员",
    },
    {
        id: "6",
        headImg: require("@/assets/avatar.png"),
        name: "张三",
        identity: "管理员",
    },
    {
        id: "7",
        headImg: require("@/assets/avatar.png"),
        name: "张三",
        identity: "管理员",
    },
    {
        id: "8",
        headImg: require("@/assets/avatar.png"),
        name: "张三",
        identity: "管理员",
    },
    {
        id: "9",
        headImg: require("@/assets/avatar.png"),
        name: "张三",
        identity: "管理员",
    },
    {
        id: "10",
        headImg: require("@/assets/avatar.png"),
        name: "张三",
        identity: "管理员",
    },
    {
        id: "11",
        headImg: require("@/assets/avatar.png"),
        name: "张三",
        identity: "管理员",
    },
    {
        id: "12",
        headImg: require("@/assets/avatar.png"),
        name: "张三",
        identity: "管理员",
    },
]

const accountTypeParams={
    null: "普通用户",
    2: "个人开发者",
    3: "团队",
    4: "企业",
  }

const sexParams = {
    0: "不详",
    1: "男",
    2: "女",
  }

  const roleType = {
      0:'所有者',
      1:'管理员',
      2:'成员'
  }

export default {
    cards,
    memberList,
    teamList,
    accountTypeParams,
    sexParams,
    roleType
}